import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import PositionViewer from "../../../../components/PagesComponents/Setting/Profile/SetupTeam/PositionViewer.component";
import PlusIcon from "../../../../assets/Icons/Universal/PlusIconWithGreenBack.svg";
import ClassRepresentativeInfoCard from "../../../../components/PagesComponents/Setting/Profile/SetupTeam/ClassRepresentativeInfoCard.component";
import SwitchTeamInfoAndEdit from "../../../../components/PagesComponents/Setting/Profile/SetupTeam/SwitchTeamInfoAndEdit.component";
import SecondModal from "../../../../components/Universal/SecondModal.component";
import Title from "../../../../components/Universal/Title.component";
import { ReactComponent as BatchIcon } from "../../../../assets/Icons/Setting/Profile/TeamBatch.svg";
import { Form, Formik } from "formik";
import FormInput from "../../../../components/Universal/FormInput.component";
const Body = ({
  positionData,
  teamInfoCardsData,
  handelUpdateCardData,
  addNewPositionModalStatus,
  setAddNewPositionModalStatus,
  addButtonElement,
  isAddable,
  handelNewPosition,
}) => {
  return (
    <div className="w-full flex-col align-left justify-start g-1 pr-1">
      <PageHeader title={"Creating teams"} />
      <SecondModal
        onClose={setAddNewPositionModalStatus}
        isOpen={addNewPositionModalStatus}
        isCrossBtn
      >
        <div className="flex-col align-center justify-start g-1 mt-2">
          <Title>Add new position</Title>
          <Formik
            initialValues={{
              color: "",
              position: "",
              positionColors: ["red", "green", "purple"],
              setColorCount: 0,
            }}
            onSubmit={(values) => {
              console.log(values);

              handelNewPosition({
                color: values?.color,
                position: values?.position,
              });
            }}
            enableReinitialize
          >
            {({ values, setFieldValue }) => {
              return (
                <Form className="flex-col align-center justify-start g-1">
                  <BatchIcon
                    fill={values.positionColors[values.setColorCount]}
                    style={{ width: "3rem", height: "3rem" }}
                  />
                  <button
                    type="button"
                    className="positionColorChangeBtn"
                    onClick={() => {
                      setFieldValue(
                        "setColorCount",
                        values?.positionColors?.length - 1 ===
                          values?.setColorCount
                          ? 0
                          : values?.setColorCount + 1
                      );

                      setFieldValue(
                        "color",
                        values.positionColors[values.setColorCount + 1]
                      );
                    }}
                  >
                    Change color
                  </button>
                  <FormInput
                    label=""
                    placeholder="Enter a new position"
                    name="position"
                  />
                  <button type="submit" className="actionBtn w-full">
                    Add new one
                  </button>
                </Form>
              );
            }}
          </Formik>
        </div>
      </SecondModal>
      <div className="w-full flex-col align-left justify-start back-white g-2 p-2 radius-10 g-1">
        <h3 className="t-18 poppins-medium color-textGray weight-500">
          Creating any operational team
        </h3>
        <div className="w-full scroll-x flex-row pt-1 pb-1" style={{ height: "6rem" }}>
          <div className="w-fit h-full flex-row align-center justify-start g-2">
            {positionData?.map((data) => {
              return (
                <PositionViewer position={data?.position} color={data?.color} />
              );
            })}
            <button
              type="button"
              className="h-full flex-row align-center justify-start g-05 radius-6 back-white pl-2 pr-2  border-greenColor pointer"
              onClick={() => setAddNewPositionModalStatus(true)}
            >
              <img
                src={PlusIcon}
                alt="plusIcon"
                style={{ width: "1.5rem", height: "1.5rem" }}
              />
              <span className="t-15 color-greenColor poppins-medium">Add</span>
            </button>
          </div>
        </div>
      </div>
      <hr className="w-full" color="#e5e5e5" />
      <div className="flex-row align-left w-full scroll-x">
        <div className="flex-row align-start justify-start g-1">
          <ClassRepresentativeInfoCard />

          {teamInfoCardsData &&
            teamInfoCardsData?.map((data) => {
              const captain = data?.teamMembers?.find(
                (member) => member?.isCaptain
              );
              const members = teamInfoCardsData?.length;
              return (
                <SwitchTeamInfoAndEdit
                  _data={{ ...data, captain: captain?.name || "", members }}
                  handelUpdateCardData={handelUpdateCardData}
                />
              );
            })}
          {isAddable ? addButtonElement() : ""}
        </div>
      </div>
    </div>
  );
};

export default Body;
